import { Box, Chip, Stack } from "@mui/material";

interface ChipListProps {
  items: string[];
  onDelete?: (item: string) => void;
  onClick?: (item: string) => void;
}

export default function ChipList({
  items,
  onDelete = () => {},
  onClick = () => {},
}: ChipListProps) {
  return (
    <Box>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {items.map((item) => (
          <Chip
            key={item}
            label={item}
            size="medium"
            onClick={() => onClick(item)}
            onDelete={() => onDelete(item)}
            variant="outlined"
            color="primary"
          />
        ))}
      </Stack>
    </Box>
  );
}